import { api } from './api';
import { getValue } from '../cache';

export async function fetchStandings(divisionId) {
  const key = 'standings-' + divisionId
  const cacheTTL = 600000

  const value = await getValue(key, async function() {
    const apiInst = await api();
    const response = await apiInst.get('division-entries?include=stats&division_id=' + divisionId);
    return response.data;
  }, cacheTTL)

  return value
}

export async function fetchEntry(id) {
  const key = 'division-entry-' + id
  const cacheTTL = 600000

  const value = await getValue(key, async function() {
    const apiInst = await api();
    const response = await apiInst.get('division-entries/' + id);
    return response.data;
  }, cacheTTL)

  return value
}

export async function fetchForClub(clubId) {
    const key = 'division-entry-club-' + clubId
    const cacheTTL = 600000

    const value = await getValue(key, async function() {
      const apiInst = await api();
      const response = await apiInst.get('division-entries?club_id=' + clubId + "&include=division");
      return response.data;
    }, cacheTTL)

    return value
}
